interface ApiRequestOptions {
  method?: string;
  body?: unknown;
  token?: string;
}

const API_KEY = process.env.REACT_APP_BACKEND_API_KEY;
if (!API_KEY) {
  throw new Error("REACT_APP_BACKEND_API_KEY is not set");
}

export async function apiRequest<T>(
  path: string,
  options: ApiRequestOptions = {},
): Promise<T> {
  const { method = "GET", body, token } = options;
  const headers: Record<string, string> = {
    "x-api-key": API_KEY,
    "Content-Type": "application/json",
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}${path}`,
    {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    },
  );

  if (!response.ok) {
    const errorData = await response
      .json()
      .catch(() => ({ message: "Unknown error" }));
    throw new Error(
      errorData.message || `HTTP error! Status: ${response.status}`,
    );
  }

  return response.json();
}

interface ApiRawResponse<T> {
  data: T;
  status: number;
}

export async function apiRequestWithStatus<T>(
  path: string,
  options: ApiRequestOptions = {},
): Promise<ApiRawResponse<T>> {
  const { method = "GET", body, token } = options;
  const headers: Record<string, string> = {
    "x-api-key": process.env.REACT_APP_BACKEND_API_KEY,
    "Content-Type": "application/json",
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}${path}`,
    {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    },
  );

  try {
    const data = await response.json();
    return { data, status: response.status };
  } catch {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
}
